import React from "react";
import { FaTimes } from "react-icons/fa";
import { useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { AWS_URL } from "../../Constant";

const CreateUser = () => {
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate()
  const handleFormSubmit = async (event) => {
    event.preventDefault();

    const formData = {
      empid: document.getElementById("empid").value,
      name: document.getElementById("name").value,
      designation: document.getElementById("designation").value,
      usertype: document.getElementById("usertype").value,
      storename: document.getElementById("storename").value,
      storeCode: document.getElementById("storeCode").value,
      phone: document.getElementById("phone").value
    };

    const jwtToken = Cookies.get("jwt_token");
// const url = "https://ec2-13-235-112-81.ap-south-1.compute.amazonaws.com/createUsersAccount";
    const url = `${AWS_URL}/createUsersAccount`
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(formData),
    };

    try {
      setLoading(true);
      const response = await fetch(url, options);
      const data = await response.json();
      
      if (response.ok) {
        setSuccessMsg("User created successfully!");
        // Clear all form fields
        document.getElementById("empid").value = "";
        document.getElementById("name").value = "";
        document.getElementById("designation").value = "";
        document.getElementById("usertype").value = "";
        document.getElementById("storename").value = "";
        document.getElementById("storeCode").value = "";
        document.getElementById("phone").value = "";
        // Clear success message after 3 seconds
        setTimeout(() => setSuccessMsg(""), 3000);
      } else {
        setErrorMsg(data?.message || "Failed to create user");
      }
    } catch (error) {
      setErrorMsg(error?.message || "Error creating user. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const setTotalStocksOpen= () =>{
    navigate('/admin')
  }

  return (
    <>
      <div className="flex flex-col h-[86vh]  rounded bg-zinc-200">
        <div className="flex justify-end  p-2">
          <FaTimes
            className="text-rose-600 cursor-pointer "
              onClick={() => setTotalStocksOpen()}
          />
        </div>
        <h1 className="text-xl text-center font-bold underline mb-5">
          Add New User
        </h1>
        <form
          className="w-full flex flex-col items-center"
          onSubmit={handleFormSubmit}
        
        >
          <div className="flex mb-2 mt-2 space-x-4" >
          <div className="w-80 flex flex-col">
              <label htmlFor="empid">Employee ID</label>
              <input
                type="text"
                className="rounded-lg form-control"
                id="empid"
              />
            </div>
            <div className="w-80 flex flex-col">
              <label htmlFor="name">name</label>
              <input
                type="text"
                className="rounded-lg form-control"
                id="name"
              />
            </div>
            </div>

        <div className="flex mb-2 mt-2 space-x-4" >
            <div className="w-80 flex flex-col">
              <label htmlFor="designation">designation</label>
              <input
                type="text"
                className="form-control rounded-lg"
                id="designation"
              />
            </div>
            <div className="w-80 flex flex-col">
              <label htmlFor="usertype">Usertype</label>
              <input
                type="text"
                className="form-control rounded-lg"
                id="usertype"
              />
            </div>
            </div>

            <div className="flex mb-2 mt-2 space-x-4" >

            <div className="w-80 flex flex-col">
              <label htmlFor="storename">storename</label>
              <input
                type="text"
                className="form-control rounded-lg"
                id="storename"
              />
            </div>
            <div className="w-80 flex flex-col">
              <label htmlFor="storeCode">storeCode</label>
              <input
                type="text"
                className="form-control rounded-lg"
                id="storeCode"
              />
            </div>
              
            </div>
            <div className="w-80 flex flex-col">
              <label htmlFor="phone">phone</label>
              <input
                type="text"
                className="form-control rounded-lg"
                id="phone"
              />
            </div>
        
            {successMsg && (
              <div className="bg-green-200 text-green-800 p-3 rounded mt-4 w-full text-center">
                {successMsg}
              </div>
            )}
            {errorMsg && (
              <div className="bg-red-200 text-red-800 p-3 rounded mt-4 w-full text-center">
                {errorMsg}
              </div>
            )}

            <button 
              className="bg-blue-500 p-2 mt-8 text-white rounded-xl w-20 mb-2 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
            
         
        </form>
      </div>
    </>
  );
};

export default CreateUser;
